import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=22b2d126&scoped=true"
import script from "./ResourcesList.vue?vue&type=script&lang=js"
export * from "./ResourcesList.vue?vue&type=script&lang=js"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&id=22b2d126&prod&lang=scss"
import style1 from "./ResourcesList.vue?vue&type=style&index=1&id=22b2d126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2d126",
  null
  
)

export default component.exports